import React from 'react';
import { useTranslation } from 'react-i18next';

const RenderSelection = ({ input, options, meta: { touched, error, warning } }) => {
  const { t } = useTranslation('upload');
  
  return (
    <div>
      <select {...input} className="form-control">
        <option value="">{t('recipient.renderSelection.recipientDropdown')}</option>
        {options.map((recipient, index) => (
          <option value={recipient.id} key={index}>
            {recipient.name}
          </option>
        ))}
      </select>
      {touched && error && (
        <span className="help-text help-text--has-error">{error}</span>
      )}
      {touched && warning && (
        <span className="help-text">{warning}</span>
      )}
    </div>
  );
};

export default RenderSelection;